define("ember-svg-jar/inlined/linkin-bio", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#a)\"><path d=\"M12.915 20.918a4.112 4.112 0 01-2.928 1.214 4.112 4.112 0 01-2.928-1.214 4.112 4.112 0 01-1.214-2.928 4.11 4.11 0 011.214-2.928l3.173-3.174-2.473-2.473-3.174 3.173a7.633 7.633 0 000 10.804 7.605 7.605 0 005.402 2.24c1.96 0 3.908-.747 5.402-2.24l3.173-3.174-2.474-2.473-3.173 3.173zM23.392 4.585a7.605 7.605 0 00-5.402-2.24c-1.96 0-3.908.747-5.402 2.24L9.415 7.758l2.473 2.474 3.174-3.174a4.112 4.112 0 012.928-1.213c1.108 0 2.147.432 2.928 1.213a4.112 4.112 0 011.214 2.929 4.112 4.112 0 01-1.214 2.928l-3.173 3.173 2.473 2.474 3.174-3.174a7.633 7.633 0 000-10.803z\"/><path d=\"M16.22 9.294l-6.922 6.922 2.459 2.458 6.921-6.921-2.458-2.459z\"/></g><defs><clipPath id=\"a\"><path d=\"M0 0h28v28H0z\"/></clipPath></defs>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "fill": "none",
      "viewBox": "0 0 28 28"
    }
  };
});